<template>
  <g>
    <polygon points="10.4,23.2 0,13.8 3.2,10.2 9.9,16.3 20.3,3.6 24,6.7 " />
  </g>
</template>
